import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { PrepareDestinationRequest } from '$/requests/PrepareDestinationRequest.ts';

const usePrepareDestination = () => {
  const mutationFn = async (request: PrepareDestinationRequest) => {
    return prepareDestination(supabaseClient, request);
  };

  return useMutation({ mutationFn });
};

export default usePrepareDestination;

async function prepareDestination(
  client: SupabaseClient,
  request: PrepareDestinationRequest
): Promise<BackendSuccessResponse<{ outcome: 'queued' | 'skipped' }>> {
  const { data, error } = await client.functions.invoke('prepare_destination', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse = (await error.context.json()) as Partial<BackendErrorResponse>;

    throw new Error(
      Array.isArray(errorResponse.errors) ? errorResponse.errors.join(', ') : 'Failed to prepare the destination'
    );
  }

  if (error) {
    throw new Error(error.message);
  }

  return data;
}
